import { HttpErrorResponse } from "@angular/common/http";

import { LoginModel } from "@core/models/login.model";
import { User } from "@core/models/user.model";
import { createAction, props } from "@ngrx/store";

export const DO_LOGIN = createAction(
  "[Auth] Do Login",
  props<{ credentials: LoginModel; target: string }>()
);

export const DO_INITIAL_LOGIN = createAction("[Auth] Do Initial Login");

export const LOGIN_SUCCESS = createAction(
  "[Auth] Login Success",
  props<{ user: User }>()
);

export const LOGIN_MFA_REQUIRED = createAction(
  "[Auth] Login MFA Required",
  props<{
    mfaToken: string;
    target: string;
  }>()
);

/** The authenticator setup lookup returned: either the user is enrolled, or setup material to scan. */
export const MFA_SETUP_LOADED = createAction(
  "[Auth] MFA Setup Loaded",
  props<{ enrolled: boolean; sharedKey?: string; authenticatorUri?: string }>()
);

/** The user submitted the code from their authenticator app on the challenge screen. */
export const VERIFY_MFA = createAction(
  "[Auth] Verify MFA",
  props<{ code: string; rememberDevice: boolean }>()
);

/** The user submitted the first code to confirm first-time authenticator enrollment. */
export const ENABLE_MFA = createAction(
  "[Auth] Enable MFA",
  props<{ code: string; rememberDevice: boolean }>()
);

/** Enrollment succeeded; the one-time recovery codes to show the user once. */
export const MFA_ENABLED = createAction(
  "[Auth] MFA Enabled",
  props<{ recoveryCodes: string[] }>()
);

/** The user acknowledged their recovery codes and wants to finish signing in. */
export const MFA_RECOVERY_ACKNOWLEDGED = createAction(
  "[Auth] MFA Recovery Acknowledged"
);

/** The user chose to complete login with a one-time recovery code instead of an app code. */
export const USE_RECOVERY_CODE = createAction(
  "[Auth] Use Recovery Code",
  props<{ recoveryCode: string; rememberDevice: boolean }>()
);

/** A two-factor setup/verify/enable step failed (invalid/expired code or token). */
export const MFA_FAILED = createAction(
  "[Auth] MFA Failed",
  props<{ error: HttpErrorResponse }>()
);

/** The user abandoned the two-factor step and returned to the password form. */
export const CANCEL_MFA = createAction("[Auth] Cancel MFA");

export const LOGIN_FAILED = createAction(
  "[Auth] Login Failed",
  props<{ error: HttpErrorResponse }>()
);

export const SET_LOGIN_LOADING = createAction(
  "[Auth] Set Login Loading",
  props<{ loading: boolean }>()
);

export const DO_LOGOUT = createAction("[Auth] Do Logout");

export const LOGOUT_SUCCESS = createAction("[Auth] Logout Success");

export const LOAD_USER_DATA = createAction("[Auth] Load User Data");

export const SET_USER_DATA = createAction(
  "[Auth] Set User Data",
  props<{ user: User }>()
);
